import styled, { css } from 'styled-components'

export const StyledSlippageBox = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 16px;

  .value {
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    color: #000000;
  }
`

export const StyledLabelWrapper = styled.div`
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 15px;
  line-height: 140%;
  letter-spacing: 0.2px;
  color: #000000;
`

export const StyledIcon = styled.img`
  width: 24px;
  height: 24px;
`

export const StyledIconExpand = styled.img`
  width: 16px;
  height: 16px;
  margin-left: 8px;
`

export const StyledIconQuestion = styled.img`
  margin-left: 4px;
  cursor: pointer;
`

export const StyledLabel = styled.span`
  margin-left: 12px;
`

export const StyledSlippageSelector = styled.div`
  flex: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 50%;
  background: #fafafc;
  border-radius: 41px;
`

export const StyledSlippageSelectorItem = styled.div<{ active: boolean }>`
  flex: auto;
  padding: 8px 0;
  border-radius: 26px;
  font-weight: 500;
  font-size: 13px;
  line-height: 140%;
  text-align: center;
  color: #2c2842;
  cursor: pointer;

  ${({ active }) =>
    active &&
    css`
      background: #ebebff;
      color: #604dbc;
    `}
`

export const StyledSlippageInput = styled.input<{
  active: boolean
  invalid: boolean
}>`
  flex: auto;
  display: flex;
  align-items: center;
  padding: 8px 12px;
  width: 50%;
  background: #fafafc;
  border: 1px solid #eff0fa;
  border-radius: 41px;
  outline: none;
  color: #2c2842;

  font-weight: 400;
  font-size: 13px;
  line-height: 140%;

  ::placeholder {
    color: #d2d7e5;
  }

  :focus {
    border: 1px solid #604dbc;
  }

  ${({ active }) =>
    active &&
    css`
      border: 1px solid #604dbc;
    `}

  ${({ invalid }) =>
    invalid &&
    css`
      color: #d05353;
      border: 1px solid #d05353;
    `}
`

export const StyledTips = styled.p<{ invalid?: boolean }>`
  padding: 8px 0 0;
  font-size: 12px;
  line-height: 16px;
  color: #9598ab;

  ${({ invalid }) =>
    invalid &&
    css`
      color: #d05353;
    `}
`
